import {
  LIBRARY_SET_PAGE_PARAMETERS,
  LIBRARY_RESET_PAGE_PARAMETERS,
  libraryCatalogueLoadBegin,
  libraryCatalogueLoadSuccess,
  libraryCatalogueLoadFailed,
  libraryItemLoadBegin,
  libraryItemLoadSuccess,
  libraryItemLoadFailed,
} from "../actions/libraryCatalogueActions";

export const pageSizePresets = {
  lower: 12,
  upper: 24,
};

const initialCatalogueState = {
  data: {},
  fetching: false,
  fetched: false,
  error: null,
};

const initialCatalogueFilterState = {
  parameters: {
    pageSize: pageSizePresets.lower,
    page: 0,
    sortBy: "",
    searchKeyword: "",
  },
};

export function libraryCatalogueItems(
  state = initialCatalogueState,
  action = {}
) {
  switch (action.type) {
    case libraryCatalogueLoadBegin:
      return { ...state, fetching: true };
    case libraryCatalogueLoadFailed:
      return { ...state, fetching: false, error: action.payload };
    case libraryCatalogueLoadSuccess: {
      return { ...state, fetching: false, fetched: true, data: action.payload };
    }
    default:
      return state;
  }
}

export function libraryCatalogueFilter(
  state = initialCatalogueFilterState,
  action = {}
) {
  switch (action.type) {
    case LIBRARY_SET_PAGE_PARAMETERS: {
      return {
        ...state,
        parameters: {
          ...state.parameters,
          ...action.payload,
        },
      };
    }
    case LIBRARY_RESET_PAGE_PARAMETERS: {
      return {
        ...initialCatalogueFilterState,
      };
    }

    default:
      return state;
  }
}

export function libraryItem(state = initialCatalogueState, action = {}) {
  switch (action.type) {
    case libraryItemLoadBegin:
      return { ...state, fetching: true };
    case libraryItemLoadFailed:
      return { ...state, fetching: false, error: action.payload };
    case libraryItemLoadSuccess: {
      return { ...state, fetching: false, fetched: true, data: action.payload };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/libraryCatalogueReducer.jsx